import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const TextLogo = ({ color = 'primary', size = 'normal' }) => {
  const sizeClass = 
    size === 'large' ? 'text-5xl' :
    size === 'responsive' ? 'text-3xl md:text-5xl' : 
    'text-3xl';

  const colorClass = 
    color === 'white' ? 'text-white' :
    color === 'secondary' ? 'text-secondary' :
    'text-primary';

  return (
    <Link 
      to="/" 
      className={`font-ephesis ${sizeClass} ${colorClass}`}
    >
      <span className="mr-4">Psikolog</span>
      <span className="mr-4">Yağmur</span>
      <span>Demiröz</span>
    </Link>
  );
}

TextLogo.propTypes = {
  color: PropTypes.oneOf(['white', 'primary', 'secondary']),
  size: PropTypes.oneOf(['normal', 'large', 'responsive'])
};

TextLogo.defaultProps = {
  color: 'primary',
  size: 'normal'
};

export default TextLogo;